import { FC, ReactNode } from "react";
import { Animated } from "../icons/Animated";

export type LoaderWithContentProps = {
  loading: boolean;
  loaderClassname?: string;
  content: ReactNode;
};

export const LoaderWithContent: FC<LoaderWithContentProps> = ({
  loading,
  loaderClassname,
  content,
}) => {
  const spinnieClassname = loaderClassname ?? "w-2 h-2 color-teal";
  const spinnieUI = () => (
    <Animated
      name="spinner"
      aria-label="Spinner Animation"
      className={spinnieClassname}
    />
  );

  return <>{loading ? spinnieUI() : content}</>;
};
